import '@/assets/css/payment-function.scss';
//import baseComponent from '@/scripts/baseComponent';
import paymentApi from '@/api/payment';
import companyInfo from '@/constant/companyInfo';
import { mapState } from "vuex";
import { paymentApiConfig } from "@/constant/config";
import commonActionHandle from "@/commonActionHandle";
import moment from "moment";
import base from "@/scripts/base";
import { PAYMENT_METHOD_ID } from "@/constant/payment";

const moreBonusGateway = {}
moreBonusGateway[PAYMENT_METHOD_ID.ONEPAY] = 4;
moreBonusGateway[PAYMENT_METHOD_ID.APPLE_PAY] = 4;
moreBonusGateway[PAYMENT_METHOD_ID.BANKING_VIETCOMBANK] = 5;

export default {
    extends: base,

    data() {
        return {
            companyInfo: companyInfo,
            listMethod: [
                {
                    id: PAYMENT_METHOD_ID.ONEPAY,
                    name: 'Onepay',
                    selected: true,
                    support: ['visa', 'master', 'americanExpress', 'jcb', 'unionPay'],
                    styleOveride: "height: 2.5rem;width: 5.5rem;"
                },
                // {
                //     id: PAYMENT_METHOD_ID.APPLE_PAY,
                //     name: 'Apple Pay',
                //     subTitle: 'Support by Onepay',
                //     selected: false,
                //     support: [],
                //     styleOveride: "height: 2.5rem;width: 5.5rem;"
                // },
                {
                    id: PAYMENT_METHOD_ID.PAYPAL,
                    name: 'Paypal',
                    selected: false,
                    support: ['visa', 'master', 'americanExpress']
                },
                // {
                //     id: PAYMENT_METHOD_ID.PAYPAL_QR, 
                //     name: 'Paypal QR',
                //     selected: false,
                //     support: ['visa', 'master', 'americanExpress']
                // },
                // {
                //     id: 'stripe',
                //     name: 'Stripe',
                //     selected: false,
                //     support: ['visa', 'master', 'americanExpress', 'jcb', 'discover', 'dinersClub', 'unionPay', 'gpay']
                // },
                // {
                //     id: PAYMENT_METHOD_ID.NGANLUONG,
                //     name: 'Ngân Lượng',
                //     selected: false,
                //     support: ['visa', 'master', 'jcb']
                // },
                {
                    id: PAYMENT_METHOD_ID.MOMO,
                    name: 'MoMo',
                    selected: false,
                },
                {
                    id: PAYMENT_METHOD_ID.BANKING_VIETCOMBANK,
                    name: 'Banking',
                    selected: false,
                },
            ],
            moreBonusGateway,
            isLoadingPolicy: false,
            listRechargePolicy: [],
            inputAmount: 230,
            inputPoint: 0,
            inputCreditPoint: 0,
            paymentMethod: PAYMENT_METHOD_ID.ONEPAY,
            isShowGetPointProcIndicator: false,
            isLoadingRecharge: false,


            promotionType: null,
            paypalQrCode: null,
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
    },

    created() {
    },

    mounted() {
        this.promotionView();
        this.onAmountChanged(this.inputAmount);
    },

    methods: {

        checkRegister() {
            console.log(moment().valueOf())
            if (this.user.registerAt + 86400000 > moment().valueOf()) {
                return true;
            } else {
                return false;
            }
        },

        // Selected policy
        selectedPolicy(id) {
            this.listRechargePolicy.forEach(element => {
                if (element.id === id) {
                    element.selected = true;
                    this.inputAmount = element.amountFrom;
                    this.onAmountChanged(element.amountFrom)
                } else {
                    element.selected = false;
                }
            })
        },

        // Selected methods
        selectedMethod(method) {
            this.listMethod.forEach(element => {
                if (element.id === method) {
                    element.selected = true;
                    this.paymentMethod = method;

                    this.promotionView();
                    this.onAmountChanged(this.inputAmount);
                } else {
                    element.selected = false;
                }
            })
        },

        // Amount change
        amountChange() {
            this.listRechargePolicy.forEach(element => {
                if (element.percent !== 0 && this.inputAmount >= element.amountFrom) {
                    if (element.amountTo === null) {
                        element.selected = true;
                    } else {
                        if (this.inputAmount <= element.amountTo) {
                            element.selected = true;
                        } else {
                            element.selected = false;
                        }
                    }
                } else {
                    element.selected = false;
                }
            })
        },

        // Promotion process
        promotionProcess(data) {
            let continueCheck = true;
            if (continueCheck && data.filter(x => x.type === 5).length > 0) {
                if (this.user.registerAt + 86400000 > moment().valueOf() && this.user.recharged === 0) {
                    this.promotionType = 5;
                    continueCheck = false;
                }
            }
            if (continueCheck && data.filter(x => x.type === 6).length > 0) {
                if (this.user.isPrime) {
                    this.promotionType = 6;
                    continueCheck = false;
                }
            }
            if (continueCheck && data.filter(x => x.type === 4).length > 0) {
                if (this.user.registerAt + 172800000 > moment().valueOf() && this.user.recharged === 0) {
                    this.promotionType = 4;
                    continueCheck = false;
                }
            }
            if (continueCheck && data.filter(x => x.type === 2).length > 0) {
                this.promotionType = 2;
                continueCheck = false;
            }
            if (continueCheck && data.filter(x => x.type === 1).length > 0) {
                this.promotionType = 1;
                continueCheck = false;
            }
            if (continueCheck && data.filter(x => x.type === 3).length > 0) {
                this.promotionType = 3;
            }
        },

        //#region Promotion view
        promotionView() {
            this.isLoadingPolicy = true;            
            let targetMethodCheck = this.paymentMethod;
            if(this.paymentMethod === PAYMENT_METHOD_ID.APPLE_PAY){
                targetMethodCheck = PAYMENT_METHOD_ID.ONEPAY;
            }
            paymentApi.promotionView(targetMethodCheck)
                .then((res) => {
                    try {
                        // res.data.splice(4, 0, {
                        //     id: 9999,
                        //     amountFrom: 2023,
                        //     amountTo: 2024,
                        //     type: 3,
                        //     percent: 100,
                        //     visible: null
                        // });
                        
                        res.data.forEach(element => {
                            //this.inputAmount = 230;
                            if (element.amountFrom === this.inputAmount) {
                                element.selected = true;
                            } else {
                                element.selected = false;
                            }
                        });

                        // console.log("🚀 ~ file: paymentGateway.js:195 ~ .then ~ res.data", res.data)
                        this.listRechargePolicy = res.data;
                        // this.promotionProcess(res.data);
                    } catch (error) {
                        console.error(error);
                    }
                    this.isLoadingPolicy = false;
                })
                .catch(error => {
                    try {
                        if (error.name === 'Error') {
                            this.$store.dispatch("common/showCommonError", error);
                        } else {
                            switch (error.errorCode) {
                                default:
                                    console.error(error);
                                    break;
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    }
                    this.isLoadingPolicy = false;
                });
        },
        //#endregion

        // Calculate iRender point
        onAmountChanged(amountValue) {
            this.amountChange();
            this.isShowGetPointProcIndicator = true;        
            let targetMethodCheck = this.paymentMethod;
            if(this.paymentMethod === PAYMENT_METHOD_ID.APPLE_PAY){
                targetMethodCheck = PAYMENT_METHOD_ID.ONEPAY;
            }
            let getPointRequest =
            {
                amount: amountValue,
                paymentMethod: targetMethodCheck
            };
            paymentApi.paymentCalculate(getPointRequest)
                .then((res) => {
                    let responData = res.data;
                    this.inputPoint = responData.irenderPoint;
                    this.inputCreditPoint = responData.bonusPoint;
                    this.isShowGetPointProcIndicator = false;
                })
                .catch(error => {
                    // try {
                    //     if (error.name === 'Error') {
                    //         this.$store.dispatch("common/showCommonError", error);
                    //     } else {
                    //         switch (error.errorCode) {
                    //             default:
                    //                 console.error(error);
                    //                 break;
                    //         }
                    //     }
                    // } catch (error) {
                    //     console.error(error);
                    // }
                    this.inputPoint = 0;
                    this.inputCreditPoint = 0;
                    this.isShowGetPointProcIndicator = false;
                });
        },

        // Pay
        pay() {
            this.createPayment();
        },

        // Create payment
        createPayment() {
            this.isLoadingRecharge = true;
            let targetMethodCheck = this.paymentMethod;
            if(this.paymentMethod === PAYMENT_METHOD_ID.APPLE_PAY){
                targetMethodCheck = PAYMENT_METHOD_ID.ONEPAY;
            }
            let request = {
                paymentMethod: targetMethodCheck,
                isApplepay: this.paymentMethod === PAYMENT_METHOD_ID.APPLE_PAY ? true : false,
                amount: parseFloat(this.inputAmount),
                deviceInformation: JSON.stringify(this.getInformationClient()),
            }
            paymentApi.createPayment(request)
                .then((res) => {
                    try {
                        let response = res.data.mainData;
                        if (targetMethodCheck === PAYMENT_METHOD_ID.PAYPAL_QR) {
                            this.paypalQrCode = response;
                        } else {
                            switch (targetMethodCheck) {
                                case PAYMENT_METHOD_ID.STRIPE:
                                    response = `${paymentApiConfig.backendHostUrl}redirect-payment-credit-card?sessionId=${response}`;
                                    break;
                                case PAYMENT_METHOD_ID.MOMO:
                                    response = response.payUrl;
                                    break;
                            }
                            var open = window.open(response, '_blank');
                            if (open == null || typeof (open) == 'undefined')
                                alert(this.$lang.payment.blockPopup);
                        }
                    } catch (error) {
                        this.$store.dispatch("commonpostAfterPayment/showUnkownError", error, this.$lang.dialog.PaymentFailed);
                    }
                    this.postAfterPayment();
                })
                .catch(error => {
                    this.postErrorPayment(error);
                });
        },

        // Post error payment
        postErrorPayment(error) {
            try {
                if (error.name === 'Error') {
                    this.$store.dispatch("common/showCommonError", error);
                } else {
                    commonActionHandle.showCustomError(
                        this.$lang.dialog.PaymentFailed,
                        error.message,
                        () => { this.inputAmount = 50; this.onAmountChanged(this.inputAmount) },
                        () => { },
                        '',
                        '',
                        false,
                    );
                }
            } catch (error) {
                this.$store.dispatch("common/showUnkownError", error, this.$lang.dialog.PaymentFailed);
            }
            this.postAfterPayment();
        },

        // Post after payment
        postAfterPayment() {
            this.isLoadingRecharge = false;
        },
    }
}